import { Select } from '@mantine/core';
import type { PayerOption } from '@/components/InvoiceDetailsModal/invoiceActions';

const labelOf = (o: PayerOption) =>
  o.selectable
    ? `${o.name} · ${o.countryCode} · ${o.clientType}${o.note ? ` · ${o.note}` : ''}`
    : `${o.name} · ${o.note}`;

export function PayerPicker({
  label,
  description,
  value,
  onChange,
  options,
}: {
  label: string;
  description?: string;
  value: number | null;
  onChange: (payerId: number | null) => void;
  options: PayerOption[];
}) {
  return (
    <Select
      label={label}
      description={description}
      value={value ? String(value) : null}
      onChange={(v) => onChange(v ? Number(v) : null)}
      data={options.map((o) => ({
        value: String(o.id),
        label: labelOf(o),
        disabled: !o.selectable,
      }))}
    />
  );
}
